import { get, post } from '@/utils/apiBase.js';

//cp 获取常见问题
const getQuestionList = option => {
    return get('/apis/product/common_question/cp/list', option)
}
//新增常见问题
const addCommonQuestion = option => {
    return post('/apis/product/common_question/add', option)
}
//修改常见问题的排序
const rankCommonQuestion = option => {
    return post('/apis/product/common_question/rank', option)
}
//删除常见问题
const delCommonQuestion = option => {
    return post('/apis/product/common_question/delete', option)
}
//常见问题更新
const updateCommonQuestion = option => {
    return post('/apis/product/common_question/update', option)
}
//常见问题申请人工
const applyCommonQuestion = option => {
    return post('/apis/product/common_question/apply_audit', option)
}
//cp获取项目的提问问题列表
const getProAskQuestion = option => {
    return get('/apis/project/cp/get_pro_ask_question', option)
}


export default {
    getQuestionList,
    addCommonQuestion,
    rankCommonQuestion,
    delCommonQuestion,
    updateCommonQuestion,
    applyCommonQuestion,
    getProAskQuestion
};